export default "__VITE_ASSET__7fef0738__"